<template>
  <div>
    <div
      style="top: 200px !important;"
      class="md-dialog upload-doc md-theme-default pr-2"
      md-active="true"
    >
      <div class="md-dialog-container" tabindex="-1">
        <div class="md-dialog-content md-theme-default">
          <span class="popup-title">Acknowledge</span>
          <span class="float-right cursor-pointer" @click="$emit('cancel')">
            <md-icon class="md-size-1x">close</md-icon>
          </span>
          <div class="popup-text mt-4">
            Add your comment bellow and click on the
            <br />Confirm button.
          </div>
          <div class="pl-2 mt-2">
            <md-field>
              <label>Comment</label>
              <md-textarea id="comment" v-model="comment"></md-textarea>
            </md-field>
          </div>
        </div>
        <div class="md-dialog-actions pr-4 pb-3">
          <md-button @click="$emit('cancel')" class="md-primary">Cancel</md-button>
          <md-button
            @click="upload"
            class="md-button md-primary md-raised c-primary pl-2 md-theme-default"
          >Confirm</md-button>
        </div>
      </div>
    </div>
    <div class="md-overlay md-fixed md-dialog-overlay"></div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {
      comment: ""
    };
  },
  methods: {
    upload() {
      let data = {
        red_flag_id: this.id,
        comment: this.comment
      };
      this.axios
        .post("/bank/acknowledge-flag", data)
        .then(data => {
          Event.$emit("message", ["Red Flag Acknowledged."]);
          this.$emit("cancel");
          this.$router.push("/bank/red-flags");
        })
        .catch(errors => {});
    }
  }
};
</script>